import { makeStateKey, StateKey } from '@angular/core';
import { PageFullUrls } from 'ctt-babylon';

export const ROUTES_KEY = makeStateKey<PageFullUrls[]>('dynamicRoutes');
export const TOKEN_KEY = makeStateKey<string>('login');

const keyPart = (value: string | number | null | undefined): string =>
    encodeURIComponent(String(value ?? ''));

export const STATIC_SITE_CONFIG_KEY = makeStateKey<any>('staticSiteConfig');

export function getGeneralConfigTransferKey<T>(
    languageId: string | number | null | undefined
): StateKey<T> {
    return makeStateKey<T>(`generalConfig:${keyPart(languageId)}`);
}

export function getRoutesTransferKey<T>(): StateKey<T> {
    return makeStateKey<T>('routesConfig');
}

export function getEngineTransferKey<T>(
    languageId: string | number | null | undefined,
    model: string | number | null | undefined,
    modelId: string | number | null | undefined
): StateKey<T> {
    return makeStateKey<T>(
        `engine:${keyPart(languageId)}:${keyPart(model)}:${keyPart(modelId)}`
    );
}

export function getPageTransferKey<T>(
    pageId: string | number | null | undefined,
    languageId: string | number | null | undefined,
    itemId: string | number | null | undefined
): StateKey<T> {
    return makeStateKey<T>(
        `page:${keyPart(pageId)}:${keyPart(languageId)}:${keyPart(itemId)}`
    );
}

export function getConsultTypeTransferKey<T>(
    languageId: string | number | null | undefined,
    model: string | number | null | undefined
): StateKey<T> {
    return makeStateKey<T>(
        `consultType:${keyPart(languageId)}:${keyPart(model)}`
    );
}
